<ion-header class="no-shadow">
  <ion-toolbar>
    <ion-title>{{ title }}</ion-title>
  </ion-toolbar>
</ion-header>

<div class="inner-content">
  <!-- HTML message -->
  <div class="message" [innerHTML]="safeMessage"></div>

  
</div>

<ion-footer class="no-shadow">
  <ion-toolbar>
    <div class="actions single">
      <ion-button class="btn-confirm" (click)="dismiss()">
        {{ okText }}
      </ion-button>
    </div>
  </ion-toolbar>
</ion-footer>